import React from "react";
import { PLATFORMS_CONFIG } from "./_components/Constants";

export const formatToLocalTime = (utcString?: string | null): string => {
    if (!utcString) return '-';

    const safeUtcString = utcString.endsWith('Z') ? utcString : `${utcString}Z`;
    const date = new Date(safeUtcString);
    const userLocale = navigator.language;

    return new Intl.DateTimeFormat(userLocale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }).format(date);
};

export const getPlatformIcon = (platformName: string) => {
  const platform = PLATFORMS_CONFIG.find(p => platformName.includes(p.name));
  return platform ? React.cloneElement(platform.icon, { sx: { color: 'gray' } }) : null;
};